import React, { Fragment } from 'react';
import { func, instanceOf, bool } from 'prop-types';
import { UTButton } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';
import { formsOptionsType, officeType, officeSlotType } from 'types/turnsTypes';

import CardCreateTurn from './components/CardCreateTurn';
import styles from './styles.module.scss';

const CreateNewTurn = ({ form, office, date, slot, handleGoOption, handleConfirmateTurn, loading }) => (
  <Fragment>
    <CardCreateTurn form={form} office={office} date={date} slot={slot} onClick={handleGoOption} />
    <UTButton loading={loading} onPress={handleConfirmateTurn} className={styles.button}>
      {message('Turns:confirmatedTurn')}
    </UTButton>
  </Fragment>
);

CreateNewTurn.propTypes = {
  form: formsOptionsType,
  office: officeType,
  date: instanceOf(Date),
  slot: officeSlotType,
  handleGoOption: func.isRequired,
  handleConfirmateTurn: func.isRequired,
  loading: bool
};

export default CreateNewTurn;
